<template>
  <div id="rootWrapper">
    <div class="actions mb-2 mt-2 hidden-print">
      <div class="pull-left">
        <b-button @click="goBackToFrom" variant="outline-dark">
          <i class="fa fa-chevron-left"></i>
          {{ $t('back')
          }}
        </b-button>
      </div>
      <div class="pull-right">
        <b-button variant="outline-dark" @click="print" class="mr-2">
          <i class="fa fa-print"></i>
          {{ $t('Печать')}}
        </b-button>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="doc-body">
      <b-card class="p-1">
        <div id="docGridWrapper">
          <DxDataGrid
            id="grid"
            :data-source="countries"
            :column-auto-width="true"
            :show-borders="true"
          >
            <DxExport
              class="hidden-print"
              :enabled="true"
              :file-name="saleForDocument ? saleForDocument.saleNumber : 'Document'"
            />

            <DxColumn
              data-field="Country"
              :allowSorting="false"
              header-cell-template="headerDataTemplate"
            />
            <DxColumn
              data-field="Area"
              :allowSorting="false"
              header-cell-template="headerAreaTemplate"
            />
            <DxColumn caption="Population">
              <DxColumn
                caption="Total"
                data-field="Population_Total"
                :allowSorting="false"
                format="fixedPoint"
              />
              <DxColumn
                caption="Urban"
                data-field="Population_Urban"
                :allowSorting="false"
                format="percent"
              />
            </DxColumn>
            <DxColumn caption="Nominal GDP">
              <DxColumn
                caption="Total, mln $"
                data-field="GDP_Total"
                :allowSorting="false"
                format="fixedPoint"
                sort-order="desc"
              />
              <DxColumn caption="By Sector">
                <DxColumn
                  :width="95"
                  :format="gdpFormat"
                  caption="Agriculture"
                  data-field="GDP_Agriculture"
                  :allowSorting="false"
                />
                <DxColumn
                  :width="80"
                  :format="gdpFormat"
                  caption="Industry"
                  data-field="GDP_Industry"
                  :allowSorting="false"
                />
                <DxColumn
                  :width="85"
                  :format="gdpFormat"
                  caption="Services"
                  data-field="GDP_Services"
                  :allowSorting="false"
                />
              </DxColumn>
            </DxColumn>
            <template #headerAreaTemplate>
              <div>
                Area, km
                <sup>2</sup>
              </div>
            </template>
            <template #headerDataTemplate>
              <span>
                <span
                  class="moldavianText nobr"
                  style="font-weight: bold"
                >Data eliberării / data livrării</span>
                <br />
                <span class="fontWeightNormal nobr">Дата выписки / дата поставки</span>
              </span>
            </template>
          </DxDataGrid>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import DxDataGrid, { DxColumn, DxExport } from "devextreme-vue/data-grid";
import { mapActions, mapState } from "vuex";
export default {
  name: "NakladnoyWithGrid",
  components: {
    DxDataGrid,
    DxColumn,
    DxExport
  },
  data() {
    return {
      countries: [
        {
          ID: 1,
          Country: "Brazil",
          Area: 8515767,
          Population_Urban: 0.85,
          Population_Rural: 0.15,
          Population_Total: 205809000,
          GDP_Agriculture: 0.054,
          GDP_Industry: 0.274,
          GDP_Services: 0.672,
          GDP_Total: 2353025
        },
        {
          ID: 2,
          Country: "China",
          Area: 9388211,
          Population_Urban: 0.54,
          Population_Rural: 0.46,
          Population_Total: 1375530000,
          GDP_Agriculture: 0.091,
          GDP_Industry: 0.426,
          GDP_Services: 0.483,
          GDP_Total: 10380380
        },
        {
          ID: 3,
          Country: "France",
          Area: 675417,
          Population_Urban: 0.79,
          Population_Rural: 0.21,
          Population_Total: 64529000,
          GDP_Agriculture: 0.019,
          GDP_Industry: 0.183,
          GDP_Services: 0.798,
          GDP_Total: 2846889
        },
        {
          ID: 4,
          Country: "Germany",
          Area: 357021,
          Population_Urban: 0.75,
          Population_Rural: 0.25,
          Population_Total: 81459000,
          GDP_Agriculture: 0.008,
          GDP_Industry: 0.281,
          GDP_Services: 0.711,
          GDP_Total: 3859547
        },
        {
          ID: 5,
          Country: "India",
          Area: 3287590,
          Population_Urban: 0.32,
          Population_Rural: 0.68,
          Population_Total: 1286260000,
          GDP_Agriculture: 0.174,
          GDP_Industry: 0.258,
          GDP_Services: 0.569,
          GDP_Total: 2047811
        },
        {
          ID: 6,
          Country: "Italy",
          Area: 301230,
          Population_Urban: 0.69,
          Population_Rural: 0.31,
          Population_Total: 60676361,
          GDP_Agriculture: 0.02,
          GDP_Industry: 0.242,
          GDP_Services: 0.738,
          GDP_Total: 2147952
        },
        {
          ID: 7,
          Country: "Japan",
          Area: 377835,
          Population_Urban: 0.93,
          Population_Rural: 0.07,
          Population_Total: 126920000,
          GDP_Agriculture: 0.012,
          GDP_Industry: 0.275,
          GDP_Services: 0.714,
          GDP_Total: 4616335
        },
        {
          ID: 8,
          Country: "Russia",
          Area: 17098242,
          Population_Urban: 0.74,
          Population_Rural: 0.26,
          Population_Total: 146544710,
          GDP_Agriculture: 0.039,
          GDP_Industry: 0.36,
          GDP_Services: 0.601,
          GDP_Total: 1857461
        },
        {
          ID: 9,
          Country: "United States",
          Area: 9147420,
          Population_Urban: 0.81,
          Population_Rural: 0.19,
          Population_Total: 323097000,
          GDP_Agriculture: 0.0112,
          GDP_Industry: 0.191,
          GDP_Services: 0.797,
          GDP_Total: 17418925
        },
        {
          ID: 10,
          Country: "United Kingdom",
          Area: 244820,
          Population_Urban: 0.82,
          Population_Rural: 0.18,
          Population_Total: 65097000,
          GDP_Agriculture: 0.007,
          GDP_Industry: 0.21,
          GDP_Services: 0.783,
          GDP_Total: 2945146
        }
      ],
      gdpFormat: {
        type: "percent",
        precision: 1
      }
    };
  },
  computed: {
    ...mapState("wholesalePos", ["saleForDocument"])
  },
  methods: {
    ...mapActions("wholesalePos", ["getSaleById"]),
    goBackToFrom() {
      this.$router.back();
    },
    print() {
      window.print();
    }
  },
  async created() {
    await this.getSaleById(this.$route.params.id);
  }
};
</script>

<style scoped lang="scss">
@media print {
  .hidden-print {
    display: none;
  }
  .dx-datagrid-header-panel {
    display: none;
  }
  .card {
    box-shadow: none;
  }
  #docGridWrapper {
    margin-top: 4cm;
    display: block;
  }
}
#rootWrapper {
  margin: 0 20px;
}
.moldavianText {
  font-weight: bold;
}

.fontWeightNormal {
  font-weight: normal;
}
.nobr {
  white-space: nowrap;
}
</style>
